import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Bleached driftwood washed up on the shore — a couple of pale, water-worn
// tapered-capsule staves, leaning where they came to rest (rounded art style,
// plan 28 stage 4).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/driftwood.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, seed }) => {
    const pale = shade(0xa9a08c, (rand(seed) - 0.5) * 0.15);
    const count = 2 + Math.floor(rand(seed + 1) * 2);
    for (let i = 0; i < count; i++) {
      const len = 0.9 + rand(seed + i * 4) * 1.3;
      const x = (rand(seed + i * 4 + 1) - 0.5) * 0.8;
      const z = (rand(seed + i * 4 + 2) - 0.5) * 0.8;
      const col = shade(pale, (rand(seed + i) - 0.5) * 0.12);
      const y = 0.13 + i * 0.03;
      const r0 = 0.11, r1 = 0.075 + rand(seed + i * 4 + 3) * 0.04; // tapered, water-worn
      // seeded endpoint y/z drift = the washed-up lean the old flat boxes faked;
      // endpoints inset by the cap radius so the stave spans ~len along x.
      const dz0 = (rand(seed + i * 4 + 5) - 0.5) * 0.12;
      const dz1 = (rand(seed + i * 4 + 6) - 0.5) * 0.12;
      const dy0 = (rand(seed + i * 4 + 7) - 0.5) * 0.05;
      const dy1 = (rand(seed + i * 4 + 8) - 0.5) * 0.05;
      bone(x - len / 2 + r0, y + dy0, z + dz0, x + len / 2 - r1, y + dy1, z + dz1, r0, r1, col);
    }
  };

export default build;
